export default __webpack_public_path__ + "static/desktop_KV11-302fdeacfa56a3833a21219a10ad9abc.mp4";